import { render, staticRenderFns } from "./jqs_zonghe_mx.vue?vue&type=template&id=0d57964d&scoped=true"
import script from "./jqs_zonghe_mx.vue?vue&type=script&lang=js"
export * from "./jqs_zonghe_mx.vue?vue&type=script&lang=js"
import style0 from "./jqs_zonghe_mx.vue?vue&type=style&index=0&id=0d57964d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57964d",
  null
  
)

export default component.exports